const devHost = 'http://local.timer.today:8081';
const prodHost = 'https://time-app.cuul.cc';

export function determineHost() {
  let hostName = window.location.hostname;
  if (hostName.indexOf('local') >-1) {
    return devHost;
  } else {
    return prodHost;
  }
}
